import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesLogin: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-login`),
};

export default pagesLogin;
